import { createFileRoute } from '@tanstack/react-router'
import { BlacklistingRequestForm } from '@/features/dashboard/blacklisting-request/components/BlacklistingRequestForm'

export const Route = createFileRoute('/_dashboard/blacklisting-requests/new')({
  component: BlacklistingRequestFormPage,
})

function BlacklistingRequestFormPage() {
  return <BlacklistingRequestForm />
}